// src/data.ts

export const stateDistricts: Record<string, string[]> = {
  Alabama: ['Northern', 'Middle', 'Southern'],
  Alaska: [],
  Arizona: [],
  Arkansas: ['Eastern', 'Western'],
  California: ['Northern', 'Southern', 'Eastern', 'Central'],
  Colorado: [],
  Connecticut: [],
  Delaware: [],
  'District of Columbia': [],
  Florida: ['Northern', 'Southern', 'Middle'],
  Georgia: ['Northern', 'Southern', 'Middle'],
  Guam: [],
  Hawaii: [],
  Idaho: [],
  Illinois: ['Northern', 'Southern', 'Central'],
  Indiana: ['Northern', 'Southern'],
  Iowa: ['Northern', 'Southern'],
  Kansas: [],
  Kentucky: ['Eastern', 'Western'],
  Louisiana: ['Eastern', 'Western', 'Middle'],
  Maine: [],
  Maryland: [],
  Massachusetts: [],
  Michigan: ['Eastern', 'Western'],
  Minnesota: [],
  Mississippi: ['Northern', 'Southern'],
  Missouri: ['Eastern', 'Western'],
  Montana: [],
  Nebraska: [],
  Nevada: [],
  'New Hampshire': [],
  'New Jersey': [],
  'New Mexico': [],
  'New York': ['Northern', 'Southern', 'Eastern', 'Western'],
  'North Carolina': ['Eastern', 'Middle', 'Western'],
  'North Dakota': [],
  'Northern Mariana Islands': [],
  Ohio: ['Northern', 'Southern'],
  Oklahoma: ['Northern', 'Eastern', 'Western'],
  Oregon: [],
  Pennsylvania: ['Eastern', 'Western', 'Middle'],
  'Puerto Rico': [],
  'Rhode Island': [],
  'South Carolina': [],
  'South Dakota': [],
  Tennessee: ['Eastern', 'Western', 'Middle'],
  Texas: ['Northern', 'Southern', 'Eastern', 'Western'],
  Utah: [],
  Vermont: [],
  'Virgin Islands': [],
  Virginia: ['Eastern', 'Western'],
  Washington: ['Eastern', 'Western'],
  'West Virginia': ['Northern', 'Southern'],
  Wisconsin: ['Eastern', 'Western'],
  Wyoming: [],
};
